import React, { useState, useEffect } from 'react';
import { verifyOtp } from '../../api/authAPI';
import { useNavigate } from 'react-router-dom';

const OtpVerification = ({ phoneNumber, onVerify, handleSteps }) => {
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(30);
  const navigate = useNavigate();
  useEffect(() => {
    const countdown = setInterval(() => {
      if (timer > 0) {
        setTimer(timer - 1);
      }
    }, 1000);
    return () => clearInterval(countdown);
  }, [timer]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await verifyOtp(phoneNumber, otp, navigate);
      onVerify();
    } catch (error) {
      console.error('Error verifying OTP:', error);
      // Handle error, e.g., show an error message
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <h4>Verify with OTP</h4>
      <p>Sent to {phoneNumber}</p>
      <form onSubmit={handleSubmit}>
        <div className="form-group otp-inputs">
          {[0, 1, 2, 3].map((_, index) => (
            <input
              key={index}
              type="text"
              className="otp-input"
              maxLength="1"
              value={otp[index] || ''}
              onChange={(e) => {
                const newOtp = otp.split('');
                newOtp[index] = e.target.value;
                setOtp(newOtp.join(''));
              }}
              required
            />
          ))}
        </div>
        <p>
          Resend OTP in: <span className="text-muted">00:{timer}</span>
        </p>
        <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
          {loading ? 'Verifying...' : 'Verify OTP'}
        </button>
        <p>
          {'Log in using'} <a href="#" onClick={handleSteps}>{'Password'}</a>
        </p>
        <p>
          {'Have trouble logging in ?'} <a href="#">{'Get help'}</a>
        </p>
      </form>
    </div>
  );
};

export default OtpVerification;
